<div class="detail-item-wrapper">
  <div class="deatil-item-icon">
    <ion-icon *ngIf="icon" [name]="icon" [ngStyle]="{ color: iconColor }"></ion-icon>
  </div>
  <div class="detail-item-text">
    <div class="value">
      <ng-content></ng-content>
    </div>
    <div class="title">
      {{ title }}
    </div>
  </div>
</div>
